export class MapValidator {
  public static isValidCoords(latitude: number): boolean {
    return !MapValidator.isInvalidLat(latitude);
  }

  private static isInvalidLat(lat: number): boolean {
    return lat > 90 || lat < -90;
  }
}
